import React, { FC, useEffect, useState } from 'react';
import injectSheet from 'react-jss';
import Lock from 'Assets/ui/lock.svg';
import RadioButton from 'Components/RadioButton';
// eslint-disable-next-line import/no-extraneous-dependencies
import { v4 } from 'uuid';
import styleSheet from './styles';
import { Button } from '../../Buttons';

interface Props {
  disabled?: boolean;
  classes?: any;
  list: any;
  errorMessage?: string;
  onCancel?: () => void;
  onSave?: (selectedValue: string) => void;
  closeModal?: () => void;
  defaultValue?: string;
}

const Permissions: FC<Props> = (props: Props) => {
  const {
    classes,
    onCancel,
    onSave,
    closeModal,
    list,
    disabled,
    errorMessage,
    defaultValue,
  } = props;

  const [selectedPermission, setSelectedPermission] = useState(defaultValue);

  const onCancelHandler = () => {
    onCancel();
    closeModal();
  };

  const onSaveHandler = (value: string) => {
    setSelectedPermission(value);
  };

  useEffect(() => {
    if (defaultValue !== undefined) {
      setSelectedPermission(defaultValue);
    }
  }, [defaultValue]);

  return (
    <>
      <div className={classes.listContainer}>
        {list.map((item: any) => {
          return (
            <div
              onClick={() => onSaveHandler(item.value)}
              onKeyUp={(event: any) => {
                if (event.key === 'Enter') {
                  onSaveHandler(item.value);
                }
              }}
              key={v4()}
              className={`${classes.row} ${classes.flexCenter}`}
              role="button"
              tabIndex={0}
            >
              <div
                className={`${classes.row} ${classes.radioButtonRows} ${classes.flexCenter} ${classes.radioButtonRowsBottomBorder}`}
              >
                <div
                  className={`${classes.col} ${classes.radioButtonCol1} ${classes.cursor}`}
                >
                  <div
                    className={`${classes.radioButtonWrapper} ${classes.cursor}`}
                  >
                    <RadioButton
                      id={item.value}
                      onClick={(e: any) => {
                        setSelectedPermission(e.target.value);
                      }}
                      isChecked={selectedPermission === item.value}
                      value={item.value}
                    />
                  </div>
                </div>

                <div
                  className={`${classes.col} ${classes.radioButtonCol2} ${classes.cursor}`}
                >
                  <p className={classes.cursor}>
                    <label
                      className={`${classes.cursor} ${classes.radioButtonBoldText}`}
                      htmlFor={item.value}
                    >
                      {item.text}
                    </label>
                    <br />
                    <label
                      className={`${classes.cursor} ${classes.radioButtonSecondaryText}`}
                      htmlFor={item.value}
                    >
                      {item.secondaryText}
                    </label>
                  </p>
                </div>
                <div
                  className={`${classes.col} ${classes.radioButtonCol3} ${classes.svgWrapper}`}
                >
                  {item.value === 'private' && (
                    <Lock className={classes.lockSvg} />
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {errorMessage && <div className={classes.error}>{errorMessage}</div>}
      <div className={classes.controls}>
        <Button onClick={onCancelHandler} buttonType="defaultClear">
          Cancel
        </Button>
        <Button
          disabled={!selectedPermission || disabled}
          onClick={() => onSave(selectedPermission)}
          buttonType="defaultBlue"
        >
          Save
        </Button>
      </div>
    </>
  );
};

Permissions.defaultProps = {
  disabled: false,
  classes: {},
  errorMessage: undefined,
  onCancel: () => {},
  onSave: () => {},
  closeModal: () => {},
  defaultValue: undefined,
};

export default injectSheet(styleSheet)(Permissions);
